import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { FiArrowUpRight, FiHome } from "react-icons/fi";
import Logo from "../assets/logos/RentlyBuzzLogo.webp";
import Building from "../assets/images/RentlyHouse.webp";
import "./_404.scss";

export function NotFound() {
  const headingRef = useRef(null);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Page not found | RentlyBuzz";
    headingRef.current?.focus({ preventScroll: true });
    window.scrollTo(0, 0);
    return () => {
      document.title = previousTitle;
    };
  }, []);

  return (
    <div className="not-found-page">
      <header className="not-found-header">
        <Link to="/" className="not-found-brand" aria-label="RentlyBuzz home">
          <img src={Logo} alt="" width="48" height="48" />
          <span>RentlyBuzz</span>
        </Link>
        <Link to="/signin" className="not-found-account">
          My account <FiArrowUpRight aria-hidden="true" />
        </Link>
      </header>

      <main className="not-found-main" aria-labelledby="not-found-heading">
        <div className="not-found-copy">
          <p className="not-found-eyebrow">404 / Page not found</p>
          <h1 id="not-found-heading" ref={headingRef} tabIndex={-1}>
            This address<br />isn’t <span>home.</span>
          </h1>
          <p className="not-found-description">
            The page you’re looking for may have moved or no longer exists.
            Let’s get you back to familiar ground.
          </p>
          <nav className="not-found-actions" aria-label="Find your way back">
            <Link to="/" className="not-found-home">
              <FiHome aria-hidden="true" /> Back to home
            </Link>
            <Link to="/signin" className="not-found-signin">
              Sign in <FiArrowUpRight aria-hidden="true" />
            </Link>
          </nav>
        </div>

        <div className="not-found-visual" aria-hidden="true">
          <span className="not-found-number">404</span>
          <div className="not-found-arch" />
          <img src={Building} alt="" className="not-found-building" />
          <span className="not-found-visual-caption">There’s always a way home.</span>
        </div>
      </main>

      <footer className="not-found-footer">
        <span>Property management. Made simple.</span>
        <span>© {new Date().getFullYear()} RentlyBuzz</span>
      </footer>
    </div>
  );
}
